@if (!hasTwoFactorAuthentication) {
    <init-two-factor-process/>
} @else {
    <two-factor-added/>
}
